import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const footerLinks = {
  gameCategories: categories.map((c) => ({ name: c.name, path: `/category/${c.slug}` })),
  quickLinks: [
    { name: '最新游戏', path: '/category/action' },
    { name: '热门排行', path: '/category/rpg' },
    { name: '文章攻略', path: '/article/top-10-butter-games-2025' },
    { name: '关于我们', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          <div>
            <h4 className="text-lg font-heading text-background-50 mb-4">黄油在线玩</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              免费黄油游戏在线平台，提供海量黄油游戏免费在线体验。无需下载安装，打开浏览器即可畅玩，支持PC与手机端。
            </p>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">游戏分类</h4>
            <ul className="space-y-2">
              {footerLinks.gameCategories.slice(0, 6).map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">快速链接</h4>
            <ul className="space-y-2">
              {footerLinks.quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-400">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5"></i>
                <span>support@huangyouzaxianwan.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-customer-service-line mt-0.5"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>中国 · 上海</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-700">
        <div className="w-full px-4 md:px-6 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 max-w-7xl mx-auto">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 黄油在线玩 huangyouzaxianwan.com 版权所有
            </p>
            <div className="flex gap-4 text-xs text-foreground-500">
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">用户协议</a>
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}